<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="foreword" id="_idContainer003" role="doc-foreword">
<p class="pl-fl-roman"><b>Elizabeth Goddard</b> is the award-winning author of more than thirty novels and novellas. A 2011 Carol Award winner, she was a double finalist in the 2016 Daphne du Maurier Award for Excellence in Mystery/Suspense, and a 2016 Carol Award finalist. Elizabeth graduated with a computer science degree and worked in high-level software sales before retiring to write full-time.</p>
<p class="pl-center"><b>Books by Elizabeth Goddard</b></p>
<p class="pl-booklist-series"><b>Love Inspired Suspense</b></p>
<p class="pl-booklist-miniseries"><span class="bold-italic">Fugitive Trail</span></p>
<p class="pl-booklist-miniseries">Mount Shasta Secrets</p>
<p class="pl-booklist-titles">Deadly Evidence</p>
<p class="pl-booklist-miniseries">Coldwater Bay Intrigue</p>
<p class="pl-booklist-titles">Thread of Revenge</p>
<p class="pl-booklist-titles">Stormy Haven</p>
<p class="pl-booklist-titles">Distress Signal</p>
<p class="pl-booklist-titles">Running Target</p>
<p class="pl-booklist-miniseries">Texas Ranger Holidays</p>
<p class="pl-booklist-titles">Texas Christmas Defender</p>
<p class="pl-booklist-miniseries">Wilderness, Inc.</p>
<p class="pl-booklist-titles">Targeted for Murder</p>
<p class="pl-booklist-titles">Undercover Protector</p>
<p class="pl-booklist-titles">False Security</p>
<p class="pl-booklist-titles">Wilderness Reunion</p>
<p class="pl-center">Visit the Author Profile page<br/>at <a href="http://www.Harlequin.com" target="_blank">Harlequin.com</a> for more titles.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// About_the_Author.vue?54dda402